import { restClient } from '@/Core/Services/RestClientService'

/**
 * Single hit returned by `GET /services/search`.
 * Backend returns a flat list of resources with a relevance `score`.
 */
export interface SearchHit {
    resource: string
    id: number
    uuid: string
    title: string
    score: number
    payload?: Record<string, any>
}

/**
 * Search all backend resources by free-form query.
 * Returns an empty array when the backend response is not a JSON array
 * (defensive — search endpoint occasionally returns `{}` on misroute).
 *
 * Throws ky exceptions on transport / 5xx errors so callers can show toasts.
 */
export const SearchResourcesTask = async (query: string): Promise<SearchHit[]> => {
    const req = restClient.get<SearchHit[]>('/services/search', {
        searchParams: { q: query },
    })
    if (!req) return []
    const response = await req
    return Array.isArray(response) ? response : []
}
